/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../../inc/LayoutFooter";
import LayoutHeader from "../../inc/LayoutHeader";
import { RollbackOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Col, Row } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { displayMessage, postAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../../constants/messages";
import {
  UPDATE_VENDOR,
  VENDOR_BY_ID,
} from "../../../constants/api";

function VendorUpdate() {
  const { Content } = Layout;
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // GET VENDOR DETAIL
  useLayoutEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    setLoading(true);

    const successFn = function (data) {
      if (data.status === true) {
        form.setFieldsValue({
          vendor_code: data.data.vendor_code,
          name: data.data.name,
          phone: data.data.phone,
          address: data.data.address,
        });
        setLoading(false);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to fetch vendor data");
    };

    postAPI(VENDOR_BY_ID, { id }, successFn, errorFn);
  };

  // UPDATE VENDOR
  const updateData = (values) => {
    setLoading(true);

    const payload = {
      id,
      ...values,
    };

    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        navigate("/laundry/vendor");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };

    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to update vendor");
    };

    postAPI(UPDATE_VENDOR, payload, successFn, errorFn);
  };

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Update Laundry Vendor"
          bordered={false}
          extra={
            <Button
              onClick={() => navigate(-1)}
              type="primary"
              ghost
              style={{ marginTop: 5, marginBottom: 5 }}
            >
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            <Form
              form={form}
              layout="vertical"
              onFinish={updateData}
            >
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Form.Item
                    name="vendor_code"
                    label="Vendor Code"
                    rules={[{ required: true, message: "Vendor Code is required" }]}
                  >
                    <Input placeholder="V001" />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="name"
                    label="Vendor Name"
                    rules={[{ required: true, message: "Vendor Name is required" }]}
                  >
                    <Input placeholder="CleanWash Laundry" />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    name="phone"
                    label="Phone Number"
                  >
                    <Input placeholder="9876543210" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item
                    name="address"
                    label="Address"
                  >
                    <Input.TextArea
                      rows={3}
                      placeholder="Lanka, Varanasi"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item style={{ float: "right" }}>
                    <Button
                      loading={loading}
                      htmlType="submit"
                      type="primary"
                    >
                      Update
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />
    </Layout>
  );
}

export default VendorUpdate;
